import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ManualRegisterModel } from '../../models/manualRegisterModel';
import { ManualRegisterItemModel } from '../../models/manualRegisterItemModel';

@Component({
  selector: 'app-manual-register',
  templateUrl: './manual-register.component.html',
  styleUrls: ['./manual-register.component.scss']
})
export class ManualRegisterComponent implements OnInit {

  @Input() inputData: any;

  @Output() itemEmitter = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    
  }

  changeChecked(identifier: string, checked: boolean) {
    this.inputData.fields.forEach(x => {
      if (x.id === identifier) {
        x.isEnabled = !x.isEnabled;
        if (!x.isEnabled) {
          x.isRequired = false;
        }
        this.changeItem(x);
      }
    })
  }

  changeRequired(identifier: string, checked: boolean) {
    this.inputData.fields.forEach(y => {
      if (y.id === identifier) {
        y.isRequired = !y.isRequired;
        this.changeItem(y);
      }
    })
  }

  changeItem(item: ManualRegisterItemModel) {
    this.itemEmitter.emit(item);
  }

}
